<template>
    <div class="indicator">
        <div class="aside">
            <div class="top" @click="topFloor">
                <img src="../../../assets/img/floorTop.png" alt="">
            </div>
            <div class="center">
                <img :src="current == -1 ?require('../../../assets/img/floorCenter.png'):require('../../../assets/img/seFloor.png')" alt="">
            </div>
            <div class="bottom" @click="bottomFloor">
                <img src="../../../assets/img/floorBottom.png" alt="">
            </div>
        </div>
        <div class="floor">
            <div class="currentfloor">
                <!-- <div v-show="selectFloors.length > 8" class="floorList" :style="{top:current == -1 ? '-200rem':-(current ) * 40 + 'rem'}">
                    <div :class="current == index? 'floorItem se':'floorItem '" v-for="(item,index) in selectFloors" :key="index +1" @click="selectFloor(index)">{{item}}</div>
                </div>
                <div v-show="selectFloors.length < 5" class="floorList1" :style="{top:current == -1 ? '-80rem':-(current ) * 81 + 'rem'}">
                    <div :class="current == index? 'floorItem se':'floorItem '" v-for="(item,index) in selectFloors" :key="index +1" @click="selectFloor(index)">{{item}}</div>
                </div> -->
                <div class="floorList3" :style="{top:current == -1 ? -(selectFloors.length / 2 ) * 32 + 16 + 'rem':-(current ) * 32 + 'rem'}">
                    <div :class="current == index? 'floorItem se':'floorItem '" v-for="(item,index) in selectFloors" :key="index +1" @click="selectFloor(index)">{{item}}</div>
                </div>
            </div>
        </div>
        <div class="bg">
            <img src="../../../assets/img/indicator.png" alt="">
        </div>
        <!-- <div class="back" @click="backUp" >
            <img src="../../../assets/img/backJian.png" alt="">
        </div> -->
        <div class="dragWindow" v-drag v-show="showSelectModel" >
            <div class="deviceName">{{device.system}}</div>
            <div class="close" @click="close"></div>
            <div class="deviceparameter">
                <div class="deviceImg">
                    <img :src="device.img" alt="">
                </div>
                <div class="deviceDetials">
                    <div class="details" v-for="(key, val,index) in device.details" :key="index">
                        <span>{{val}}</span><span>{{key}}</span>
                    </div>
                    <div class="details" >
                        <span>安装位置:</span><span>{{currentBuild}}{{getFloorId}}</span>
                    </div>
                </div>
            </div>
            <div class="parameter">
                <el-menu
                    :default-openeds="opens"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose">
                    <el-submenu :index="index + ''" v-for="(item,index) in device.parameter" :key="index">
                        <template slot="title">
                            <span>{{item.title}}</span>
                        </template>
                        <div class="ptab" v-for="(key, val,index) in item.details" :key="index">
                            <span>{{val}}</span><span>{{key}}</span>
                        </div>
                    </el-submenu>
                </el-menu>
            </div>
        </div>
        <div class="dragWindowMonitor" v-drag v-show="showMonitor" >
            <div class="deviceName">{{device.system}}</div>
            <div class="close" @click="close1"></div>
            <div class="warp">
                <div class="deviceparameter">
                    <div class="deviceImg">
                        <img :src="device.img" alt="">
                    </div>
                    <div class="deviceDetials">
                        <div class="details" v-for="(key, val,index) in device.details" :key="index">
                            <span>{{val}}</span><span>{{key}}</span>
                        </div>
                    </div>
                </div>
                <div class="monitor">
                    <div class="iframeM">
                        <iframe  width="100%" height="100%"  :src="'https://www.energydt.cn/proxy/webrtc/index.html?' + monitorsrc" frameborder="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div class="dragWindowDian" v-drag v-show="showDianbiao" >
            <div class="deviceName">{{device.system}}</div>
            <div class="close" @click="closeDianbiao"></div>
            <div class="deviceparameter">
                <div class="deviceImg">
                    <img :src="device.img" alt="">
                </div>
                <div class="deviceDetials">
                    <div class="details" >
                        <span>设备名称</span><span>{{meterName}}</span>
                    </div>
                    <div class="details" v-for="(key, val,index) in device.details" :key="index">
                        <span>{{val}}</span><span>{{key}}</span>
                    </div>
                </div>
            </div>
            <div class="chart">
                <div id="main"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:['selectFloors'],
    inject:['buildId', 'floorId'],
    data(){
        return {
            opens:['0','1'],
            current:-1,
            showSelectModel:false,
            showMonitor:false,
            showDianbiao:false, // 电表箱
            showDianbiaoRoom:false, // 房间电表
            meterName:'电表', // 当前电表名字
            device:{},
            monitorsrc:'DP01',
            deviceParameter:{  
                air:{   // 空调
                    system:'暖通系统设备信息',
                    img:require('../../../assets/img/air.png'),
                    details:{
                        '设备名称:':'多联式室内机',
                        '设备编号:':'6F-A10-1',
                        '设备型号:':'FXSP112CAN',
                        // '安装位置:':`主楼6F`,
                    },
                    parameter:[
                        {
                            title:'设备参数',
                            details:{
                                "类型:":'多联机中央空调',
                                "品牌:":'生产品牌',
                                "制冷量:":'2.20kw',
                                "制热量:":'2.5kw',
                                "外形尺寸:":'710*450*200mm',
                                "额定功率:":'23kW',
                            }
                        },
                    ]
                },
                paifeng:{   // 排风扇
                    system:'暖通系统设备信息',
                    img:require('../../../assets/img/paiqishan.png'),
                    details:{
                        '设备名称:':'吸顶导管式排风扇',
                        '设备编号:':'6F-A10-1',
                        '设备型号:':'FXSP112CAN',
                        // '安装位置:':`主楼6F`,
                    },
                    parameter:[
                        {
                            title:'设备参数',
                            details:{
                                "类型:":'排气扇',
                                "品牌:":'生产品牌',
                                "功率:":'100W',
                                "风量:":'720m³/h',
                                "外形尺寸:":'600*600mm',
                                "额定功率:":'68kW',
                            }
                        },
                    ]
                },
                songFeng:{
                    system:'暖通系统设备信息',
                    img:require('../../../assets/img/songfengkou.png'),
                    details:{
                        '设备名称:':'双层格栅送风口',
                        '设备编号:':'6F-A10-1',
                        '设备型号:':'FXSP112CAN',
                        // '安装位置:':`主楼6F`,
                    },
                    parameter:[
                        {
                            title:'设备参数',
                            details:{
                                "类型:":'中央空调出风口',
                                "品牌:":'生产品牌',
                                "功能:":'出风口保护',
                                "风量:":'1800m³/h',
                                "安装深度:":'3.5CM',
                                "外形尺寸:":'600*600mm',
                                "额定功率:":'68kW',
                            }
                        },
                    ]
                },
                guanDao:{
                    system:'暖通系统设备信息',
                    img:require('../../../assets/img/guandao.png'),
                    details:{
                        '设备名称:':'防火网管',
                        '设备编号:':'6F-A10-1',
                        '设备型号:':'FXSP112CAN',
                        // '安装位置:':`主楼6F`,
                    },
                    parameter:[
                        {
                            title:'设备参数',
                            details:{
                                "类型:":'排烟通风管道',
                                "品牌:":'生产品牌',
                                "功能:":'通风排烟',
                                "通风动力:":'排烟风机',
                                "耐火温度:":'1580~1770℃',
                                "外形尺寸:":'1300*2300mm*14mm',
                            }
                        },
                    ]
                }
            },
            deviceParameterLight:{ // 
                can:{  // 筒灯
                    system:'照明系统设备信息',
                    img:require('../../../assets/img/whiteTongDeng.png'),
                    details:{
                        '设备名称:':'圆形吸顶筒灯',
                        '设备编号:':'6-TD-2',
                        '设备型号:':'YXTD',
                        // '安装位置:':`主楼6F`,
                    },
                    parameter:[
                        {
                            title:'设备参数',
                            details:{
                                "类型:":'LED明装筒灯',
                                "光源功率:":'5W',
                                "色温:":'3000K',
                                "光通量:":'4000lm',
                                "寿命:":'36000h',
                            }
                        },
                    ]
                },
                danLED:{
                    system:'照明系统设备信息',
                    img:require('../../../assets/img/danLED.png'),
                    details:{
                        '设备名称:':'单管LED灯',
                        '设备编号:':'6-TD-2',
                        '设备型号:':'YXTD',
                        // '安装位置:':`主楼6F`,
                    },
                    parameter:[
                        {
                            title:'设备参数',
                            details:{
                                "类型:":'LED支架灯',
                                "光源功率:":'2*18W',
                                "色温:":'3000K',
                                "光通量:":'80lm',
                                "外形尺寸":'1266*60mm',
                                "寿命:":'36000h',
                            }
                        },
                    ]
                },
                shuangLED:{
                    system:'照明系统设备信息',
                    img:require('../../../assets/img/shuangLED.png'),
                    details:{
                        '设备名称:':'双管LED灯',
                        '设备编号:':'6-TD-2',
                        '设备型号:':'YXTD',
                        // '安装位置:':`主楼6F`,
                    },
                    parameter:[
                        {
                            title:'设备参数',
                            details:{
                                "类型:":'LED支架灯',
                                "光源功率:":'2*18W',
                                "色温:":'3000K',
                                "光通量:":'80lm',
                                "外形尺寸":'1266*60mm',
                                "寿命:":'50000h',
                            }
                        },
                    ]
                },
                tianpeng:{
                    system:'照明系统设备信息',
                    img:require('../../../assets/img/tianpengdeng.png'),
                    details:{
                        '设备名称:':'天棚灯',
                        '设备编号:':'6-TD-2',
                        '设备型号:':'YXTD',
                        // '安装位置:':`主楼6F`,
                    },
                    parameter:[
                        {
                            title:'设备参数',
                            details:{
                                "类型:":'LED天棚灯(带蓄电池)',
                                "光源功率:":'60W',
                                "色温:":'5700K',
                                "光通量:":'3500lm',
                                "外形尺寸":'300*300mm',
                                "寿命:":'15000h',
                            }
                        },
                    ]
                }
            },
            deviceParameterMonitor:{
                system:'安防系统设备信息',
                img:require('../../../assets/img/monitorimg.png'),
                details:{
                    '设备名称:':'室内枪机摄像头',
                    '设备编号:':'6F-S10-6',
                    '设备型号:':'SNQJ',
                    // '安装位置:':`主楼6F`,
                },
                monitorSrc:''
            },
            deviceParameterDian:{ // 
                light:{
                    system:'能耗系统设备信息',
                    img:require('../../../assets/img/dianbiao.png'),
                    details:{
                        // '设备名称:':'主楼7层照明',
                        '设备参数:':'125A/380V/50HZ',
                        '电源引自:':'AL14-2 F2',
                        '用电量:':`37.7kWh`,
                        '电压:':`220.8V`,
                        '电流:':`4.12A`,
                    },
                },
                fire:{
                    system:'能耗系统设备信息',
                    img:require('../../../assets/img/dianbiao.png'),
                    details:{
                        // '设备名称:':'主楼7层消防',
                        '设备参数:':'125A/380V/50HZ',
                        '电源引自:':'APEB1-1A(常)/1B(备)',
                        '用电量:':`37.7kWh`,
                        '电压:':`220.8V`,
                        '电流:':`4.12A`,
                    },
                },
                power:{
                    system:'能耗系统设备信息',
                    img:require('../../../assets/img/dianbiao.png'),
                    details:{
                        // '设备名称:':'主楼7层动力',
                        '设备参数:':'50A/380V/50HZ',
                        '电源引自:':'AL09-3 F2',
                        '用电量:':`37.7kWh`,
                        '电压:':`220.8V`,
                        '电流:':`4.12A`,
                    },
                },
                room:{
                    system:'能耗系统设备信息',
                    img:require('../../../assets/img/hudianbiao.png'),
                    details:{
                        // '设备名称:':'主楼7层办公电能表',
                        '设备参数:':'50A/380V/50HZ',
                        '电源引自:':'AL09-3 F2',
                        '用电量:':`37.7kWh`,
                        '电压:':`220.8V`,
                        '电流:':`4.12A`,
                    },
                }
            },
            option : {
                title: {
                    text:'kWh',
                    x: '1%',
                    y: '-2%',
                    textStyle:{                  //标题样式
                        fontSize: '12',
                        fontFamily:'Source Han Sans CN',
                        color:'rgba(230,243,253, 0.7)',
                    }
                },
                
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    axisLine:{
                        lineStyle:{
                            color:'#0D94FF'
                        }
                    },
                     axisLabel: {
                        color: "rgba(230,243,253, 0.7)"  //坐标轴的文本颜色
                    },
                    axisTick:{       
                        "show":false   //去掉x轴刻度线
                    },
                },
                tooltip: {
					trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
                    backgroundColor: 'rgba(0, 10, 26, 0.8)',
                    borderRadius: 8,  
                    borderWidth: 0,
                    shadowColor:'rgba(13, 148, 255, 0.8)',
					axisPointer: {// 坐标轴指示器，坐标轴触发有效
						type: 'line', // 默认为直线，可选为：'line' | 'shadow'
					},
                    textStyle: {
                        color: '#fff'
                    },
                },
                
                yAxis: {
                    type: 'value',
                    axisLine:{
                        show:false,
                        lineStyle:{
                            color:'rgba(230,243,253, 0.7)'
                        }
                    },
                    splitLine: {           //分割线
                        show: false,     //控制分割线是否显示
                        // lineStyle:{       //分割线的样式
                        //     color: ['rgba(43,70,126,1)'],
                        //     width: 2,
                        //     type: 'solid'
                        // }
                        },
                },
                series: [
                    {
                        data: [82, 93, 90, 34, 29, 33, 120, 82, 93, 90, 34, 29, 33, 120,82, 93, 90, 34, 29, 33, 120,82, 93, 90, 34],
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        // color: this.color || ['#0D94FF'] ,
                        areaStyle: {
                            color: this.color? 'rgba(246,189,22,0.3)':'rgba(13,148,255,0.3)'   //折线区域的背景颜色
                        },
                        itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: this.color || '#0D94FF' //折线的颜色
                                }  ,
                                color: '#0D94FF',  //拐点颜色
                            },
                            emphasis:{
                                color:this.color || '#0D94FF',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                            
                        },
                    },
                ],
                grid: {
                    left: "3%",
                    right: "5%",
                    bottom: "6%",
                    top: "15%",
                    containLabel: true,
                },
            },
            myChart:null
        }
    },
    computed:{
        getBuildId(){
			return this.buildId()
		},
		getFloorId(){
			return this.floorId()
		},
        currentBuild(){
            let build = this.$store.state.Cang.buildTree.find(item => item.id == this.getBuildId)
            return build.name
        }
    },
    watch:{
        current(val){
            console.log(val);
            if(val == -1){
                return
            }
            this.$emit('selectFloor',this.selectFloors[val])
        },
        getBuildId(){
            this.current = -1,
            this.selectDevice()
        }
    },
    created(){
        let arr = []
        for(let i = 0;i<=24;i++){
            let dian = i<10? i.toString().padStart(2,'0').padEnd(5,':00') :i.toString().padEnd(5,':00')
            arr.push(dian)
        }
        this.option.xAxis.data = arr
    },
    mounted(){
        window.addEventListener('resize',this.chartResize)
        // 4.监听更新事件
        window.addEventListener('beforeunload', this.clearChart);

        
    },
    methods:{
        clearChart(){
            // 手动触发 destroy 相关的生命周期，
            this.$destroy();
        },
        chartResize(){
            //防抖
            if(this.timer)
                clearTimeout(this.timer)
            this.timer = setTimeout(()=>{
                this.myChart.resize();
            },500)
        },
        selectFloor(idx){
            this.current = idx
        },
        topFloor(){
            if(this.current <= 0){
                this.current = 0
            }else{
                this.current --
            }
        },
        bottomFloor(){
            if(this.current >= this.selectFloors.length -1){
                this.current = this.selectFloors.length -1
            }else{
                this.current ++
            }
        },
        backUp(){
            this.current = -1
            this.$emit('backBuild')
        },
        close(){
            this.$emit('cancelModel')
        },
        close1(){
            this.$emit('cancelModel')
        },
        closeDianbiao(){
            this.$emit('closeMeter')
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        initChart(){
            this.myChart = echarts.getInstanceByDom(document.getElementById('main'));
            if(this.myChart == null){
                this.myChart = echarts.init(document.getElementById('main'));
            }
            this.option && this.myChart.setOption(this.option);
        },
        selectDevice(device){
            console.log('选中设备' + device);
            let _this = this
            if(!device){
                this.showSelectModel = false
                this.showMonitor = false
                this.showDianbiao = false
                return 
            }
            switch(device.type){
                case 'mesh': // 模型
                    console.log('mesh');
                    if(device.device.includes('TonFeng') || device.device.includes('KonTiao')){
                        _this.showSelectModel = true
                        if(device.device.includes('GuanDao') && !device.device.includes('ZhongYangKonTiao') ){
                            _this.device = _this.deviceParameter.guanDao
                        }else if(device.device.includes('FangXingFengKou')){
                            _this.device = _this.deviceParameter.paifeng
                        }else if(device.device.includes('ShuangCengFengKou')){
                            _this.device = _this.deviceParameter.songFeng
                        }else if(device.device.includes('ZhongYangKonTiao') ){
                            _this.device = _this.deviceParameter.air
                        }
                    }else if(device.device.includes('ZhaoMing') ){
                        _this.showSelectModel = true
                        
                        if(device.device.includes('ShuangGuanLedDeng')){
                            _this.device = _this.deviceParameterLight.shuangLED
                        }else if(device.device.includes('DanGuanLedDeng')){
                            _this.device = _this.deviceParameterLight.danLED
                        }else if(device.device.includes('TongDeng')){
                            _this.device = _this.deviceParameterLight.can
                        }else if(device.device.includes('TianPengDeng') ){
                            _this.device = _this.deviceParameterLight.tianpeng
                        }
                    }
                    break;
                case 'monitor': // 监控
                    console.log('monitor');
                    _this.device = _this.deviceParameterMonitor
                    _this.showMonitor = true
                    switch(device.device){
                        case 'JianKon_qj1' :
                            _this.monitorsrc = 'CHDiscern'
                            break;
                        case 'JianKon_qj2' :
                            _this.monitorsrc = 'CHLobby'
                            break;
                        case 'JianKon_qj3' :
                            _this.monitorsrc = 'CHLobby'
                            break;
                        case 'JianKon_qj4' :
                            _this.monitorsrc = 'LTDS002'
                            break;
                        case 'JianKon_qj5' :
                            _this.monitorsrc = 'CHLobby'
                            break;
                        default :
                            _this.monitorsrc = 'DP01'
                    }
                    break;
                case 'meter': // 电表
                    console.log('meter');
                    _this.showDianbiao = true
                    _this.meterName = _this.getFloorId + device.device + '电能表'
                    _this.device = _this.deviceParameterDian.room
                    _this.initChart()
                    break;
                case 'pdx': // 配电箱
                    console.log('pdx');
                    _this.showDianbiao = true
                    switch(device.device){
                        case 'PDX1_1' :
                            _this.device = _this.deviceParameterDian.fire
                            _this.meterName = _this.getFloorId + '消防配电箱'
                            _this.initChart()
                            break;
                        case 'PDX2_1' :
                            _this.device = _this.deviceParameterDian.light
                            _this.meterName = _this.getFloorId + '照明配电箱'
                            _this.initChart()
                            break;
                        case 'PDX3_1' :
                            _this.device = _this.deviceParameterDian.power
                            _this.meterName = _this.getFloorId + '动力配电箱'
                            _this.initChart()
                            break;
                        case 'PDX4_1' :
                            _this.device = _this.deviceParameterDian.light
                            _this.meterName = _this.getFloorId + '照明配电箱'
                            _this.initChart()
                            break;
                        default :
                            console.log('none');
                    }
                    break;
                default :
                    console.log('none');
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .indicator{
        width: 6.5vw;
        height: 90vh;
        position: fixed;
        top: 7.9vh;
        right: 22vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        z-index: 1;
        .aside{
            width: 1.5vw ;
            height: 100%;
            padding: 40vh 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            .top{
                width: 1.5vw;
                height: 1.5vw;
                &>img{
                    width: 100%;
                    height: 100%;
                }
            }
            .center{
                width: 1.2vw;
                height: 1.2vw;

                &>img{
                    width: 100%;
                    height: 100%;
                }
            }
            .bottom{
                width: 1.5vw;
                height: 1.5vw;
                &>img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .floor{
            width: 2.5vw ;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .currentfloor{
                width: 48rem;
                height: 32rem;
                box-sizing: border-box;
                position: relative;
                // background: url(../../../assets/img/floorser.png) no-repeat;
                // background-size: 150% 150% ;
                // background-position: center center;
                .floorList{
                    width: 100%;
                    height: 432rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    position: absolute;
                    left: 0;
                    transition: all 1s ease-in-out;
                    
                    .floorItem{
                        width: 48rem;
                        height: 32rem;
                        box-sizing: border-box;
                        background: url(../../../assets/img/floornor.png) no-repeat;
                        background-size: 150% 170% ;
                        background-position: center center;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #E6F3FD;
                        text-align: center;
                        line-height: 32rem;
                        cursor: pointer;
                        // box-shadow: 0 0 5rem #269AFF, 0 0 5rem #269AFF;
                    }
                    .se{
                        background: url(../../../assets/img/floorser.png) no-repeat;
                        background-size: 150% 150% ;
                        background-position: center center;
                    }
                }
                .floorList1{
                    width: 100%;
                    height: 194rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    position: absolute;
                    left: 0;
                    transition: all 1s ease-in-out;
                    
                    .floorItem{
                        width: 48rem;
                        height: 32rem;
                        box-sizing: border-box;
                        background: url(../../../assets/img/floornor.png) no-repeat;
                        background-size: 150% 150% ;
                        background-position: center center;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #E6F3FD;
                        text-align: center;
                        line-height: 32rem;
                        cursor: pointer;
                        // box-shadow: 0 0 5rem #269AFF,0 0 5rem #269AFF,0 0 5rem #269AFF;
                    }
                    .se{
                        background: url(../../../assets/img/floorser.png) no-repeat;
                        background-size: 150% 150% ;
                        background-position: center center;
                    }
                }

                .floorList3{
                    width: 100%;
                    // display: flex;
                    // flex-direction: column;
                    // justify-content: space-between;
                    position: absolute;
                    left: 0;
                    transition: all 1s ease-in-out;
                    
                    .floorItem{
                        width: 48rem;
                        height: 32rem;
                        box-sizing: border-box;
                        background: url(../../../assets/img/floornor.png) no-repeat;
                        background-size: 150% 150% ;
                        background-position: center center;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #E6F3FD;
                        text-align: center;
                        line-height: 32rem;
                        cursor: pointer;
                        // box-shadow: 0 0 5rem #269AFF,0 0 5rem #269AFF,0 0 5rem #269AFF;
                    }
                    .se{
                        background: url(../../../assets/img/floorser.png) no-repeat;
                        background-size: 150% 150% ;
                        background-position: center center;
                    }
                }
            }
            
        }
        .bg{
            width: 2vw ;
            height: 100%;
            &>img{
                width: 100%;
                height: 100%;
            }
        }
        .back{
            width: 70rem;
            height: 70rem;
            position: fixed;
            bottom: 4vh;
            right: calc(50vw - 35rem);
            border-radius: 50%;
            background: url(../../../assets/img/backcircle.png);
            background-size: 100% 100%;
            img{
                width: 50rem;
                height: 50rem;
                position: absolute;
                top:0;
                right:0;
                bottom:0;
                left:0;
                margin:auto;
            }
        }
        .dragWindow{
            width: 17vw;
            height: 44vh;
            background:url(../../../assets/img/Popupbj.png) no-repeat;
            background-size: 100% 100%;
            position: fixed;
            top: 40vh;
            left: 53vw;
            padding: 0.8vh 0;
            .deviceName{
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #0D94FF;
                padding-left: 3vw;
                padding-bottom: 2.4vh;
            }
            .close{
                cursor: pointer;
                width: 8px;
                height: 10px;
                position: absolute;
                right: 1vw;
                top: 4vh;
                background:url(../../../assets/img/pupupClose.png) no-repeat;
                background-size: 100% 100%;
            }
            .deviceparameter{
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding: 0 1vw;
                .deviceImg{
                    width: 6vw;
                    height: 12vh;
                    &>img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .deviceDetials{
                    width: 8vw; 
                    height: 100%;
                    font-size: 14rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #E6F3FD;
                    display: flex;
                    flex-direction: column;
                    // justify-content: space-evenly;
                    padding: 1vh 0;
                    .details{
                        display: flex;
                        justify-content: space-around;
                        align-items:center;
                        height: 2.5vh;
                        line-height: 2.5vh;
                        border-bottom: 1rem solid rgba(6,134,253, 0.7);
                        &>span{
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        &>span:nth-child(1){
                            font-size: 12rem;
                            color: rgba(230,243,253, 0.7);
                            height: 100%;
                            width: 42%;
                            text-align: center;
                            border-right: 1rem solid rgba(6,134,253, 0.7);
                        }
                        &>span:nth-child(2){
                            height: 100%;
                            width: 58%;
                            text-align: left;
                            padding-left: 8rem;
                        }
                    }
                    
                }
            }
            .parameter{
                overflow-x: hidden;
                overflow-y: scroll;
                padding: 0 0.3vw 0 1vw;
                height: 25vh;
                width: 98%;
                /deep/.el-menu{
                    background: none;
                    text-align: center;
                    border-right: none;
                    .el-submenu__title{
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #E6F3FD;
                        background:url(../../../assets/img/parameter.png) no-repeat;
                        background-size: 100% 100%;
                        height: 3vh;
                        line-height: 3vh;
                        margin-top: 2vh;
                    }
                    .el-icon-arrow-down:before{
                        font-size: 20rem;
                        font-weight: bold;
                        color: #0D94FF;
                        transform: rotate(90deg);
                    }
                    .el-menu--inline{
                        padding-top: 0;
                    }
                    .ptab{
                        width: 100%;
                        height: 3vh;
                        border-bottom: 1px solid rgba(6,134,253, 0.7);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        position: relative;

                        &>span:nth-child(1){
                            font-size: 12rem;
                            color: rgba(230,243,253, 0.7);
                        }
                        &>span:nth-child(2){
                            font-size: 14rem;
                            color: #E6F3FD;
                        }
                    }
                    .ptab::before{
                        content: '';
                        width: 1px;
                        height: 3vh;
                        background-color:rgba(6,134,253, 0.7);
                        position: absolute;
                        top: 0;
                        left: 4vw;
                    }
                }
            }
            .parameter::-webkit-scrollbar{
                width:6rem ;
            }
            .parameter::-webkit-scrollbar-thumb {
                border-radius: 6rem;
                background: #84C9FF;
                border-radius: 3rem;
            }
        }
        .dragWindowMonitor{
            width: 35vw;
            height: 32vh;
            background:url(../../../assets/img/monitorBj.png) no-repeat;
            background-size: 100% 100%;
            position: fixed;
            top: 50vh;
            left: 37vw;
            padding: 0.8vh 0;
            .deviceName{
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #0D94FF;
                padding-left: 3vw;
                padding-bottom: 2vh;
            }
            .close{
                cursor: pointer;
                width: 8px;
                height: 10px;
                position: absolute;
                right: 1vw;
                top: 4vh;
                background:url(../../../assets/img/pupupClose.png) no-repeat;
                background-size: 100% 100%;
            }
            .warp{
                height: 87%;
                width: 98%;
                display: flex;
                justify-content: space-between;
                .deviceparameter{
                    height: 100%;
                    width: 11vw;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    padding: 0 1vw;
                    .deviceImg{
                        width: 6.5vw;
                        height: 13vh;
                        &>img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .deviceDetials{
                        width: 100%; 
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #E6F3FD;
                        display: flex;
                        flex-direction: column;
                        // justify-content: space-evenly;
                        padding: 1vh 0;
                        .details{
                            display: flex;
                            justify-content: space-around;
                            align-items:center;
                            height: 2.5vh;
                            line-height: 2.5vh;
                            border-bottom: 1rem solid rgba(6,134,253, 0.7);
                            &>span{
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            &>span:nth-child(1){
                                font-size: 12rem;
                                color: rgba(230,243,253, 0.7);
                                height: 100%;
                                width: 42%;
                                text-align: center;
                                border-right: 1rem solid rgba(6,134,253, 0.7);
                            }
                            &>span:nth-child(2){
                                height: 100%;
                                width: 58%;
                                text-align: left;
                                padding-left: 0.3vw;
                            }
                            
                        }
                        
                    }
                }
                .monitor{
                    margin-top: 0.7vh;
                    width: 23vw;
                    height: 24.7vh;
                    background:#0D94FF;
                    background-size: 100% 100%;
                    border: 2rem solid #0D94FF;
                    clip-path: polygon(28rem 0, calc(100% - 28rem) 0, 100% 28rem, 
                        100% calc(100% - 28rem), calc(100% - 28rem) 100%,
                        28rem 100%, 0 calc(100% - 28rem), 0 28rem);
                    .iframeM{
                        width: 100%;
                        height: 100%;
                        background:#000;
                        clip-path: polygon(28rem 0, calc(100% - 28rem) 0, 100% 28rem, 
                        100% calc(100% - 28rem), calc(100% - 28rem) 100%,
                        28rem 100%, 0 calc(100% - 28rem), 0 28rem);
                    }
                }
            }
            
        }

        .dragWindowDian{
            width: 20vw;
            height: 42vh;
            background:url(../../../assets/img/Popupbj.png) no-repeat;
            background-size: 100% 100%;
            position: fixed;
            top: 40vh;
            left: 53vw;
            padding: 0.8vh 0;
            .deviceName{
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #0D94FF;
                padding-left: 3.5vw;
                padding-bottom: 2.4vh;
            }
            .close{
                cursor: pointer;
                width: 16rem;
                height: 16rem;
                position: absolute;
                right: 1vw;
                top: 4vh;
                background:url(../../../assets/img/pupupClose.png) no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
            }
            .deviceparameter{
                width: 100%;
                display: flex;
                // justify-content: space-between;
                padding: 0 1vw;
                .deviceImg{
                    width: 7.5vw;
                    height: 15vh;
                    &>img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .deviceDetials{
                    width: 10.5vw; 
                    height: 100%;
                    font-size: 14rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #E6F3FD;
                    display: flex;
                    flex-direction: column;
                    // justify-content: space-evenly;
                    .details{
                        display: flex;
                        justify-content: space-around;
                        align-items:center;
                        height: 2.5vh;
                        line-height: 2.5vh;
                        border-bottom: 1rem solid rgba(6,134,253, 0.7);
                        &>span{
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        &>span:nth-child(1){
                            font-size: 12rem;
                            color: rgba(230,243,253, 0.7);
                            height: 100%;
                            width: 35%;
                            text-align: center;
                            border-right: 1rem solid rgba(6,134,253, 0.7);
                        }
                        &>span:nth-child(2){
                            height: 100%;
                            width: 65%;
                            text-align: left;
                            padding-left: 8rem;
                        }
                    }
                    .details:last-child{
                        border: none;
                    }
                }
            }
            .chart{
                height: 20vh;
                padding-top: 2vh;
                position: relative;
                #main{
                    width: 19.5vw;
                    height: 18vh;
                }
                &::before{
                    content:'';
                    width: 91%;
                    height: 1px ;
                    background-color: rgba(6,134,253, 0.7);
                    position: absolute;
                    top: 1vh;
                    left: 0;
                    right: 0;
                    margin: auto;
                }
            }
        }
    }
</style>